import { render, staticRenderFns } from "./OCButton.html?vue&type=template&id=528085f6&scoped=true&"
import script from "./OCButton.ts?vue&type=script&lang=ts&"
export * from "./OCButton.ts?vue&type=script&lang=ts&"
import style0 from "./OCButton.css?vue&type=style&index=0&id=528085f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528085f6",
  null
  
)

export default component.exports